export const withSearchParams = (route: string, params: URLSearchParams) =>
  `${route}?${params.toString()}`;
